<div class="switch round {{ color }}-switch">
  <label class="m-0">
    <input type="checkbox" [checked]="value" (change)="onValue($event.target.checked)">
    <span class="lever m-0"></span>
  </label>
</div>